/**
 * Normalizes an authored CSS color to the 6-digit hex the native color input
 * requires, so the picker reflects the current value instead of reverting to
 * black. Browsers serialize `style.color` back as `rgb(...)`, so a hex-only
 * check would miss every round-tripped color. Falls back to black for values
 * the picker can't represent (named colors, unset, alpha).
 * @param value - The authored color value ("" when unset)
 * @returns A 6-digit hex color
 */
export function toHexColor(value: string): string {
  if (/^#[0-9a-fA-F]{6}$/.test(value)) {
    return value.toLowerCase();
  }
  const shortHex = /^#([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])$/.exec(value);
  if (shortHex) {
    const [, r, g, b] = shortHex;
    return `#${r}${r}${g}${g}${b}${b}`.toLowerCase();
  }
  const rgb = /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/.exec(value);
  if (rgb) {
    const [, r, g, b] = rgb;
    return `#${[r, g, b].map((part) => Number(part).toString(16).padStart(2, "0")).join("")}`;
  }
  return "#000000";
}
